/** Settings shell tab keys for `/dashboard/settings` (and `/dashboard/profile`). */
export const PROFILE_SETTINGS_TAB_NAMES = [
  'personal',
  'profile',
  'professional',
  'office',
  'security',
  'notifications',
  'preferences',
] as const;

export type ProfileSettingsTabName = (typeof PROFILE_SETTINGS_TAB_NAMES)[number];

/** Primary header / account-menu deep link into the public Profile tab. */
export const PROFILE_AND_SETTINGS_NAV_PATH = '/dashboard/settings?tab=profile';
